import React from "react";
import { useState,useEffect } from "react";
import { Helmet } from 'react-helmet';
import './classes/AthleteRequestApproval.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';
import AgencySidebar from "./AgencySidebar";
import SalespersonSidebar from "./SalespersonSidebar";

const AthleteRequestApproval = () => {

    const [isLoading, setIsLoading] = useState(true);
    const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
    const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
    const app_url = configData.APP_URL;
    var {drupal_uid} = useParams();
    useEffect(() => {
        Promise.all([
            getuserloggedinroles()
        ])
        .then(() => {
    
        setIsLoading(false);
        })
    
    },[]);

    async function getuserloggedinroles() {
        try {
            setIsLoading(true);
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
               
               setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
        } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
    } 

    return (
        <>
         {isLoading ? (
              <Loading />
            ) : (
                <div id="main" className="athlete-request-approval-main">
                    <Helmet><title>Athlete request approval</title></Helmet>
                    <div className="left">
                        <div>
                            <h2>Represented By</h2>
                            <p>No athlete found.</p>
                        </div>
                    </div>
                    <div className="center left-center">
                        <div className="athlete-request-approval-container">
                            <div>Your athlete has been submitted to be publicly displayed viewable at <a href={"https://"+configData.RSMWW_AGENCY_DOMAIN}>SMWWAgency.com.</a></div>
                            <div style={{color: "red", fontWeight: "bold"}}>Your athlete will be visible AFTER SMWW staff approves the changes.</div>
                            <div><a href={"/view_athlete/"+drupal_uid}>Return to your athlete's page</a></div>
                        </div>
                    </div>
                    <div className="right">
                        <AgencySidebar />
                        {((userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))) ? 
                            (<SalespersonSidebar/>
                            ) : (
                            <>
                            <h1>Quick Links</h1>    
                            <ul className="user-opt-menu" style={{paddingLeft:"0px"}}>       
                                <li className='agent-header-hello-text'><a href={"/user/"+loggedin_drupal_uid+"/edit"} className="agent-quick_link_anchor">Manage My Profile</a></li>
                                <li>
                                <a href="/smww_pay">
                                    <input type="button" className='agent-quick-links-reg-button' value="Register for a Course"/>
                                </a>
                                </li>
                            </ul>  
                            </>
                        )} 
                    </div>
                </div>
            )}
        </>
    );
};
export default AthleteRequestApproval;